import api from '../api/client';

const getAll = async (appId, tenantId = null) => {
    if (!appId) throw new Error('App ID is required');
    // is_active '0' = no filter: disabled users must stay listed, or their card (and its
    // Enable button) vanishes the moment they're disabled. '1' would hide them.
    const params = { app_id: appId, is_active: '0' };
    if (tenantId) params.tenant_id = tenantId;
    const res = await api.get(`/api/user/get-all-users`, { params });
    return res?.data?.data;
};

const getAllActiveUsersAcrossApps = async () => {
    try {
        // Get all active users using app_id=all flag (portal admin only)
        // This is used when creating a new app to show all users regardless of app association
        const params = { app_id: 'all', is_active: '1' };
        console.log('Fetching all active users with params:', params);
        const res = await api.get(`/api/user/get-all-users`, { params });
        return res?.data?.data || [];
    } catch (err) {
        console.error('Failed to fetch all active users:', err);
        throw err;
    }
};

const updateStatus = async (username, is_active) => {
    const res = await api.post('/api/user/update-user-status', { username, is_active });
    return res?.data;
};

const updateDetails = async (appId, payload, tenantId = null) => {
    const params = { app_id: appId };
    if (tenantId) params.tenant_id = tenantId;
    const res = await api.post('/api/user/update-user-details', payload, { params });
    return res?.data;
};

const createUser = async (appId, payload, tenantId = null) => {
    const params = { app_id: appId };
    if (tenantId) params.tenant_id = tenantId;
    const res = await api.post('/api/reg/create-user', payload, { params });
    return res?.data;
};

const unlockAccount = async (username) => {
    const res = await api.post('/api/user/unlock-account', { username });
    return res?.data;
};

const bulkUpdateStatus = async (usernames, is_active) => {
    const res = await api.post('/api/user/bulk-update-status', { usernames, is_active });
    return res?.data;
};

const usersService = {
    getAll,
    getAllActiveUsersAcrossApps,
    updateStatus,
    updateDetails,
    createUser,
    unlockAccount,
    bulkUpdateStatus,
};

export default usersService;
